import { render } from "./ShekhForm.vue?vue&type=template&id=597eb22c"
import script from "./ShekhForm.vue?vue&type=script&lang=js"
export * from "./ShekhForm.vue?vue&type=script&lang=js"
script.render = render

export default script